/**
 * Legacy: Notification Bar
 *
 * @module legacy/LNotificationBar
 */


// Dependances
// ============================================================================

import { $ } from '../common/utility/u-jquery-$';
import { UCookies } from '../common/utility/u-cookies';


// Vars
// ============================================================================

const $container = $('#page-container');
const $header    = getHeaderEl();

const $bar    = $('.on24-notification-bar');
const $close  = $('.on24-notification-bar .on24-notifications-close');
const $slider = $('.on24-notification-bar .slick-slider');



// ƒ
// ============================================================================

/**
 * Core module init
 *
 * @return  {void}
 */
function _moduleInit()
{
	if ($bar.length)
	{
		if ($('#header').length)
		{
			HeaderV1NotificationBar();
		}

		if ($('#site-header').length)
		{
			HeaderV2NotificationBar();
		}

		if ( $( '.v3-header' ).length )
		{
			v3NotificationBar();
		}
	}
}


/**
 * Gets the relevant jQuery header element object, depending on V1/V2
 *
 * @return  {jQuery}  jQuery element object
 */
function getHeaderEl()
{
	if ( $('#header').length )
	{
		return $('#header');
	}
	else if ( $('#site-header').length )
	{
		return $('#site-header');
	}
	else if ( $( '.v3-header' ).length )
	{
		return $( '.v3-header' );
	}
	else
	{
		return null;
	}
}


function HeaderV1NotificationBar()
{
	// TEMPORARY CODE TO PAD OLD HEADER
	var should_pad = true;

	$slider.on('init afterChange', () =>
	{
		if (should_pad)
		{
			var pad = $bar.height();

			$header.css( { 'transform': 'translate(0, ' + pad + 'px)' } );
			$container.css( { 'padding-top': pad + 'px' } );
		}
	});
	// END TEMPORARY CODE

	$close.on('click', () =>
	{
		UCookies.setCookie('banner_notification', 1, 7);
		closed_banner = true;

		$bar.stop().slideUp(300);

		// TEMPORARY CODE TO PAD OLD HEADER
		should_pad = false;
		$header.css( { 'transform': 'translate(0, 0)' } );
		$container.css( { 'padding-top': 0 } );
		// END TEMPORARY CODE
	});

	initNotificationSlider( false );

	$header.css('transition', 'none');
	$container.css('transition', 'none');
}


function HeaderV2NotificationBar()
{
	let should_pad = true;

	$slider.on('init afterChange', () =>
	{
		if (should_pad)
		{
			let pad = 0;

			if ($bar.hasClass('minimised'))
			{
				pad = 0;
			}
			else
			{
				if ($(window).width() >= 1024)
				{
					pad = $header.outerHeight(true) - $header.find('.site-header__primary').height() - $header.find('.site-header__secondary').height() - 15;
				}
				else
				{
					pad = $header.outerHeight(true) - $header.find('.site-header__primary').height();
				}
			}

			$container.css( { 'margin-top': pad + 'px' } );
		}
	});

	$close.on('click', function()
	{
		UCookies.setCookie('banner_notification', 1, 7);

		$bar.addClass('closed').stop().slideUp(300);
		$header.css( { 'top': '0' } );
		$container.css( { 'margin-top': 0 } );

		should_pad = false;
	});

	initNotificationSlider( true );
}


/**
 * Init notification bar for V3
 *
 * @return  {void}
 */
function v3NotificationBar()
{
	$close.on('click', () =>
	{
		UCookies.setCookie( 'banner_notification', 1, 7 );
		$bar.stop().hide();
		$( 'body' ).removeClass( 'has-notification-bar' );
	});

	initNotificationSlider( true );
}


/**
 * Init slick slider for the notification bar's slides.
 * Does nothing if there are no slides
 *
 * @param   {boolean}  hasAdaptiveHeight  True to use the `adaptiveHeight` option (v2), false if not (v1)
 *
 * @return  {void}
 */
function initNotificationSlider( hasAdaptiveHeight = false )
{
	if ( !$slider.length )
	{
		return;
	}

	$slider.slick({
		slidesToShow: 1,
		slidesToScroll: 1,
		dots: true,
		arrows: false,
		rows: 0,
		speed: 800,
		autoplay: true,
		autoplaySpeed: 7000,
		adaptiveHeight: hasAdaptiveHeight, // V1: false, V2: true
		accessibility: false,
	});
}


// Auto Init
// ============================================================================

$( document ).ready( () => _moduleInit() );
